import { IPhoneNumber } from '../offer';

export interface IUserState {
  // TODO: При использовании постепенно заполнять тип
  agencyName?: string;
  agentAccountType: EAgentType;
  balance: number; // сейчас приходит string, но должен быть number
  billingInfo?: IBillingInfo;
  canPayByCard: boolean;
  canUseHiddenBase: boolean;
  cianName: string;
  cianProfileStatus: EProfileStatus;
  cianUserId: number;
  email: string;
  gaType: string;
  hasVerifiedPhoneNumber: boolean;
  homeownerInfo?: IHomeownerInfo;
  isBuilder: boolean;
  isSubAgent: boolean;
  limitedBalance?: number;
  agencyBalance: number;
  moneySource?: EMoneySource;
  phoneNumbers: Array<IPhoneNumber>;
  showOffrepBanner: boolean;
  status: EAccountStatus;
  subAgentCanPublishOffers: boolean;
  termsHintAbGroup: string;
  userId: number;
  userTrustLevel: ETrustLevel;
  geo?: IUserGeo;
  showAgencyBalance: boolean;
  auctionPoints?: IAuctionPoints;
}

export interface IBillingInfo {
  accountType: EAccountType;
  packages: Array<IPackage>;
}

export interface IPackage {
  countryId: number;
  depositRequired: boolean;
  geoName: string;
  locationId: number;
  packageTypeId: EUserTariffType;
  packageTypeName: string;
}

export interface IHomeownerInfo {
  userType: EHomeownerType;
  canPublishAsHomeowner: boolean;
}

/** Геопозиция пользователя */
export interface IUserGeo {
  /** квадрат координат (чего?) */
  bbox?: string;
  /** имеет ли город метро */
  hasUnderground: boolean;
  /** id локации пользователя (locationId) */
  id: number;
  /** широта локации пользователя */
  lat: number;
  /** долгота локации пользователя */
  lng: number;
  /** название города пользователя */
  name: string;
  /** название города пользователя в дательном падеже */
  name_dative: string;
}

export interface IAuctionPoints {
  balance: number;
  lastExpiringDate: string;
  lastExpiringBalance: number;
}

/** Тип плательщика */
export enum EAccountType {
  /** Юр. лицо */
  Legal = 'legal',
  /** Физ. лицо */
  Natural = 'natural',
}

/** Тип аккаунта специалиста */
export enum EAgentType {
  /** агентство */
  agency = 'agency',
  /** управляющая компания **/
  managementCompany = 'managementCompany',
  /** отдел аренды **/
  rentDepartment = 'rentDepartment',
  /** специалист **/
  specialist = 'specialist',
}

/** Тип аккаунта собственника */
export enum EHomeownerType {
  /** специалист */
  specialist = 'specialist',
  /** собственник */
  homeowner = 'homeowner',
}

/** Участие в акции "Работаю честно" */
export enum ETrustLevel {
  /** Не участвует в акции */
  notInvolved = 'notInvolved',
  /** Участвует в акции */
  involved = 'involved',
  /** Новый пользователь */
  new = 'new',
  /** Исключен из программы */
  excluded = 'excluded',
  /** Очень много жалоб */
  danger = 'danger',
}

/** Статус аккаунта */
export enum EAccountStatus {
  /** Активный */
  active = 'active',
  /** заблокирован **/
  blocked = 'blocked',
  /** удален **/
  deleted = 'deleted',
}

/** Статус профиля */
export enum EProfileStatus {
  /** утвержден-отмодерирован публичный профиль **/
  approved = 'approved',
  /** скрыт публичный профиль **/
  hide = 'hide',
  /** запрос на публикацию публичного профиля **/
  request = 'request',
}

/** Тариф пользователя */
export enum EUserTariffType {
  NonCommercial = 1,
  Base = 2,
  Pro = 3,
  Builder = 5,
}

/** Источник средств субагента */
export enum EMoneySource {
  /** Со счёта агентства */
  Master = 'master',
  /** С личного счёта  */
  Self = 'self',
}
